import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=642078fe&"
import script from "./TransactionTable.vue?vue&type=script&lang=js&"
export * from "./TransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports